import { Auth0DefaultConfig } from "./Auth0Context";
import { NOTIFICATION_MAP, LAST_ATTEMPT } from "./constant";

const getLanguage = (culture: any) => {
  const language = (culture || "en").split("-")[0];
  return language.length === 2 ? language : "en";
};

const getCountryCode = (culture: any) => {
  const countryCode = (culture || "en-IE").split("-");
  return countryCode.length === 2 ? countryCode[1] : "IE";
};

export function saveLastAttemptInfo (data: any) {
  window.localStorage.setItem(LAST_ATTEMPT, JSON.stringify(data));
}

export function getLastAttemptInfo () {
  return (window.localStorage.getItem(LAST_ATTEMPT) || "{}");
}

export function pushDataToSegment (
  name: string,
  isPageInformation: boolean,
  additionalProperties?: object
) {
  const { wauth: wauthString } = Auth0DefaultConfig;

  if (wauthString) {
    const wauth = JSON.parse(atob(wauthString));
    if (wauth?.site?.toLowerCase() === "vistacreate") {
      wauth.site = "vistacreate";
    }

    const cleanedUrl = window.location.origin + window.location.pathname; // to prevent search parameters from being logged.

    let data: any = {
      // https://vistaprint.atlassian.net/wiki/spaces/GA/pages/2335539331/Sign-In+Page+tracking#Events-calls
      anonymousId: wauth.anonymousId,
      context: {
        page: {
          path: window.location.pathname,
          title: document.title,
          url: cleanedUrl
        }
      },
      properties: {
        pageSection: "Login",
        pageStage: "My Account",
        path: window.location.pathname,
        title: document.title,
        url: cleanedUrl,
        trackingTenant: wauth.site,
        source: wauth.site,
        language: getLanguage(wauth.culture),
        locale: getCountryCode(wauth.culture),
        visit: wauth.visit,
        ga_cookie_id: wauth.ga,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        testUserId: wauth.optimizelyId || undefined,
        storeId: wauth.storeId || undefined
      }
    };
    let type;

    if (isPageInformation) {
      type = "page";
      data.name = name;
      data.properties.pageName = name;
      data.properties = Object.assign(data.properties, additionalProperties);
    } else {
      type = "track";
      data.event = NOTIFICATION_MAP[name] || name;
      data.properties.category = "Login";
      data.properties = Object.assign(data.properties, additionalProperties);
    }

    const segmentUrl = `${process.env.REACT_APP_SEGMENT_DATA_URL}?type=${type}`;

    if (navigator.sendBeacon) {
      navigator.sendBeacon(segmentUrl, JSON.stringify(data));
    }
  }
}
